module.exports = __webpack_public_path__ + "assets/img/btn3@2x.de3ac92a.png";